// import DeepTissueMassageImage from '../assets/images/Treatments/AyurvedicBackMassage/back-massage-1.png';
// import WeightLossImage from '../assets/images/Treatments/AyurvedicFacial/facial-1.png';
// import MindRelaxImage from '../assets/images/Treatments/Nawarakizhi/nawarakizhi-2.png';
// import StressReliefRitualImage from '../assets/images/Treatments/AyurvedicHeadMassage/head-massage-5.png';
// import HalfDayAyrvedicSpaRitualImage from '../assets/images/Treatments/AyurvedicHeadMassage/head-massage-1.png';
// import FullDayAyrvedicSpaRitualImage from '../assets/images/Treatments/Shirodara/shirodara-1.png';

import DeepTissueMassageImage from '../assets/images/Packages/deep-tissue-massage-1.png';
import WeightLossImage from '../assets/images/Packages/weight-loss-1.png';
import MindRelaxImage from '../assets/images/Packages/mind-relax-1.png';
import StressReliefRitualImage from '../assets/images/Packages/stress-relief-ritual-1.png';
import HalfDayAyrvedicSpaRitualImage from '../assets/images/Packages/half-day-ayurvedic-spa-ritual-1.png';
import FullDayAyrvedicSpaRitualImage from '../assets/images/Packages/full-day-ayurvedic-spa-ritual-1.png';

const PackagesData = [
    {
        id: 1,
        title: "වේදනාහරණී",
        subtitle: "Deep Tissue Massage",
        description:
            "The place is close to Barceloneta Beach and bus stop just 2 min by walk and near to where you can enjoy the main night life in Barcelona.",
        alt: "Deep Tissue Massage Package Image",
        src: DeepTissueMassageImage,
    },
    {
        id: 2,
        title: "දේහ ස්ථූලහර",
        subtitle: "Weight Loss",
        description:
            "Fragrance  that subtle something, that quality of air that emanation from old trees, that so wonderfully changes and renews a weary spirit.",
        alt: "Weight Loss Package Image",
        src: WeightLossImage,
    },
    {
        id: 3,
        title: "මනං සන්තුට්ඨී",
        subtitle: "Mind Relaxing",
        description: "Massage Description that subtle something, that quality of air that emanation from old trees, that so wonderfully changes and renews a weary spirit.",
        alt: "Mind Relaxing Package Image",
        src: MindRelaxImage,
    },
    {
        id: 4,
        title: "නිදහස",
        subtitle: "Stress Relief Ritual",
        description: "Massage Description that subtle something, that quality of air that emanation from old trees, that so wonderfully changes and renews a weary spirit.",
        alt: "Stress Relief Ritual Package Image",
        src: StressReliefRitualImage,
    },
    {
        id: 5,
        title: "සතුට",
        subtitle: "Half Day Ayrvedic Spa Ritual",
        description: "Massage Description that subtle something, that quality of air that emanation from old trees, that so wonderfully changes and renews a weary spirit.",
        alt: "Half Day Ayrvedic Spa Ritual Package Image",
        src: HalfDayAyrvedicSpaRitualImage,
    },
    {
        id: 6,
        title: "ගම්භාරි",
        subtitle: "Full Day Ayrvedic Spa Ritual",
        description: "Massage Description that subtle something, that quality of air that emanation from old trees, that so wonderfully changes and renews a weary spirit.",
        alt: "Full Day Ayrvedic Spa Ritual Package Image",
        src: FullDayAyrvedicSpaRitualImage,
    },
];

export default PackagesData;